import ResourceService from './resource.service'

class TrainingTypeService extends ResourceService {
  static get resource() {
    return 'training-type'
  }
}

export default TrainingTypeService
